"use strict";
// @ts-ignore
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CalculateDistances_1 = __importDefault(require("../google/CalculateDistances"));
var GeocodeAddress_1 = __importDefault(require("../google/GeocodeAddress"));
var state_1 = require("../state");
var helpers_1 = require("./helpers");
var modalsHandler_1 = require("./modalsHandler");
var formEventHandlers_1 = require("./formEventHandlers");
exports.default = (function () {
    var updateMatchingAdvisors = function (updatedAdvisorPool, wizard) {
        if (wizard === void 0) { wizard = state_1.state.wizard; }
        var activeStep = state_1.state.activeStep, zipCode = state_1.state.zipCode, queryInProgress = state_1.state.queryInProgress;
        // Return early if:
        // 1. On step 2 and no zip code entered (zip is required on step 2)
        // 2. No location selected (should always have a location)
        // 3. Async query is still in progress
        if (((activeStep === 2 && !zipCode) || !wizard.location.length || queryInProgress)) {
            return state_1.state.matchingAdvisors;
        }
        var matchingAdvisors = updatedAdvisorPool.filter(function (advisor) {
            var advisorWizardKeys = Object.keys(advisor.wizard);
            var everyResult = advisorWizardKeys.every(function (key) {
                // Pass with a true if it is empty, or if there is a matching element
                if (!wizard[key].length || key === 'location' || helpers_1.findCommonElements(wizard[key], advisor.wizard[key])) {
                    return true;
                }
                return false;
            });
            return everyResult;
        });
        state_1.setState({ matchingAdvisors: matchingAdvisors });
        //console.log(state);
        return matchingAdvisors;
    };
    var onWizardUpdate = function (state, update) {
        var wizard = update.wizard;
        var availableAdvisorPool = state.availableAdvisorPool, activeStep = state.activeStep;
        if (activeStep == 2 && state.wizard.location !== wizard.location) {
            updateAdvisorPool(state.zipCode, wizard.location);
            return false;
        }
        updateMatchingAdvisors(availableAdvisorPool, wizard);
    };
    var parseDestinationResponse = function (response, offices) {
        var destinations = response.rows[0].elements;
        // Loop through the results and find the destinations within range and save the keys
        // We will use these keys to cross reference with the advisorOffices array to get the names
        var keysOfLocationsInRange = destinations.reduce(function (keys, result, index) {
            if (result.status === 'OK' && result.distance.value < helpers_1.DISTANCE_IN_METERS) {
                keys.push(index);
            }
            return keys;
        }, []);
        // Get location names using previously gathered keys of in range offices. 
        // These results will be used to find advisors with office locations in this array.
        var namesOfLocationsInRange = keysOfLocationsInRange.reduce(function (localOffices, index) {
            localOffices.push(offices[index]);
            return localOffices;
        }, []);
        return namesOfLocationsInRange;
    };
    // This function will recalculate the available regional advisor pool 
    // and forecefully re-run the wizard filtering function.
    var findNearbyAdvisorPool = function (zipCode) { return __awaiter(void 0, void 0, void 0, function () {
        var advisors, SafeSizedDestinations, geocodePromise, distancePromise, _a, geocodeResponse, distanceResponse, geoCodeComponents, stateShortName, stateAbbreviations, parsedDestinations, namesOfLocationsInRange, availableAdvisorByOffice, availableAdvisorPool;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    advisors = state_1.state.advisors;
                    SafeSizedDestinations = helpers_1.splitArray(state_1.state.advisorOffices);
                    geocodePromise = GeocodeAddress_1.default(zipCode);
                    distancePromise = CalculateDistances_1.default(zipCode, SafeSizedDestinations);
                    return [4 /*yield*/, Promise.all([geocodePromise, distancePromise])];
                case 1:
                    _a = _b.sent(), geocodeResponse = _a[0], distanceResponse = _a[1];
                    geoCodeComponents = geocodeResponse.results[0].address_components;
                    stateShortName = '';
                    stateAbbreviations = [
                        'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA',
                        'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA',
                        'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND',
                        'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT',
                        'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'
                    ];
                    geoCodeComponents.forEach(function (component) {
                        if (stateAbbreviations.includes(component.short_name)) {
                            stateShortName = component.short_name;
                        }
                    });
                    state_1.setState({ queryInProgress: false });
                    if (!distanceResponse) {
                        formEventHandlers_1.setZipStatusIconState('hidden');
                        console.error('Something went wrong looking up the advisors');
                        return [2 /*return*/];
                    }
                    formEventHandlers_1.setZipStatusIconState('valid');
                    parsedDestinations = distanceResponse.map(function (res, index) { return parseDestinationResponse(res, SafeSizedDestinations[index]); });
                    namesOfLocationsInRange = Array.prototype.concat.apply([], parsedDestinations);
                    if (!namesOfLocationsInRange.length) {
                        state_1.setState({ availableAdvisorPool: [] });
                        return [2 /*return*/, false];
                    }
                    availableAdvisorByOffice = advisors.filter(function (advisor) { return advisor.officeLocations.some(function (location) { return namesOfLocationsInRange.some(function (locationInRange) { return location === locationInRange; }); }); });
                    availableAdvisorPool = availableAdvisorByOffice.filter(function (advisor) { return advisor.statesServed.some(function (state) { return state === stateShortName || state === 'ALL'; }); });
                    state_1.setState({ availableAdvisorPool: availableAdvisorPool });
                    return [2 /*return*/, true];
            }
        });
    }); };
    var calculateAcceptableAdvisors = function (zipCode) {
        var advisors = state_1.state.advisors;
        GeocodeAddress_1.default(zipCode).then(function (response) {
            state_1.setState({ queryInProgress: false });
            if (!response) {
                formEventHandlers_1.setZipStatusIconState('hidden');
                console.error('Something went wrong looking up the advisors');
                return;
            }
            formEventHandlers_1.setZipStatusIconState('valid');
            var geoCodeComponents = response.results[0].address_components;
            var stateShortName = '';
            var stateAbbreviations = [
                'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA',
                'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA',
                'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND',
                'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT',
                'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'
            ];
            geoCodeComponents.forEach(function (component) {
                if (stateAbbreviations.includes(component.short_name)) {
                    stateShortName = component.short_name;
                }
            });
            //console.log(stateShortName);
            var availableAdvisorPool = advisors.filter(function (advisor) { return advisor.statesServed.some(function (state) { return state === stateShortName || state === 'ALL'; }); });
            state_1.setState({ availableAdvisorPool: availableAdvisorPool });
        });
    };
    var updateAdvisorPool = function (zipCode, location) {
        if (location.includes(0)) {
            return findNearbyAdvisorPool(zipCode);
        }
        return calculateAcceptableAdvisors(zipCode);
    };
    // This function only fires when the zip code has been updated.
    // The goal is to reduce google distance matrix calls.
    var onZipCodeUpdate = function (state, update) {
        var zipCode = update.zipCode;
        var wizard = state.wizard;
        // Don't run this if there is no zipcode, or if the zipcode is unchanged
        if (!zipCode || state.zipCode === zipCode) {
            return false;
        }
        state_1.setState({ queryInProgress: true });
        formEventHandlers_1.setZipStatusIconState('pending');
        updateAdvisorPool(zipCode, wizard.location);
    };
    state_1.subscribe('zipCode', onZipCodeUpdate);
    state_1.subscribe('wizard', onWizardUpdate);
    state_1.subscribe('matchingAdvisors', function (oldState, update) {
        // Show the no results modal when matching advisors count changes to 0
        var matchingAdvisorsCountHasChanged = update.matchingAdvisors.length !== oldState.matchingAdvisors.length;
        var isNowZero = !update.matchingAdvisors.length;
        if (isNowZero && matchingAdvisorsCountHasChanged) {
            // Prevent rapid-fire modal calls by checking the current state
            if (state_1.state.matchingAdvisors.length === 0) {
                modalsHandler_1.showNoResultsModal();
            }
        }
    });
    state_1.subscribe('availableAdvisorPool', function (state, update) {
        updateMatchingAdvisors(update.availableAdvisorPool);
    });
});
